<template>
  <div class="">
    <div class="text-2xl">
      Import opportunities from Mercury
    </div>

    <OpportunityList></OpportunityList>

    <div class="py-6 px-4">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import OpportunityList  from "./OpportunityList"
  import { EventBus }     from '@/shared/event-bus';
  import PageHeader       from '@/shared/components/headers/PageHeader'
  import SubmitButton     from '@/shared/components/form/SubmitButton'
  import Footer           from '@/shared/components/Footer'

  export default {

    components : {
      OpportunityList,
      SubmitButton,
      PageHeader,
      Footer
    },
  }
</script>